// import { Col, Row } from "antd";
// import React from "react";
// import General_Info from "../../components/generalInfo";
// export default function ProductUpdate(props) {
//   return (
//     <Row>
//       <Col span={24}>
//         <General_Info
//           textHeading={"Update Product"}
//           isShowUpdateProduct={true}
//           {...props}
//         />
//       </Col>
//     </Row>
//   );
// }

import General_Info from "../../components/generalInfo";
import { Row, Col } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
class ProductUpdate extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Row>
        <Col span={24}>
          <General_Info
            textHeading={
              !this.props?.location?.state?.id
                ? "New Product"
                : "Update Product"
            }
            isShowUpdateProduct={true}
            {...this.props}
          />
        </Col>
      </Row>
    );
  }
}
function mapStateToProps(store) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductUpdate);
